import React from 'react';
import { VStack } from 'native-base';
import Section from '~/shared/Section';
import { Caption, H1 } from '~/shared/Typography';
import { SpIcon } from '~/shared/Icon';
import { faCompass } from '@fortawesome/free-solid-svg-icons';
import { useShopStyles } from '~/shared/styles';
import { useI18n } from '@springbig/shared';

export const LocationPermission = () => {

    const { icon } = useShopStyles();
    const { t } = useI18n();

    return (
        <Section flex={1} px={16} justifyContent={'center'}>
            <VStack alignItems={'center'} space={12}>
                <H1 textAlign={'center'} mb={0}>
                    { t('shop.grant_location_permission') }
                </H1>
                <SpIcon color={icon} icon={faCompass} size={96} />
                <Caption textAlign={'center'}>
                    { t('shop.location_permissions_are_required') }
                </Caption>
                <Caption textAlign={'center'}>
                    { t('shop.permissions_can_be_reset') }
                </Caption>
            </VStack>
        </Section>
    );
};
